import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import register from '@/components/register'
import personal from '@/components/personal'
import mybook from '@/components/mybook'
import bookdetail from '@/components/bookdetail'
import cmtlist from '@/components/cmtlist'
import changepwd from '@/components/changepwd'
import feedback from '@/components/feedback'
import catalog from '@/components/catalog'
import read from '@/components/read'
import readpay from '@/components/readpay'
import loadpage from '@/components/loadpage'
import search from '@/components/search'
import homepage from '@/components/index/homepage'
import man from '@/components/index/man'
import more from '@/components/index/more'
import woman from '@/components/index/woman'
import rank from '@/components/index/rank'
import end from '@/components/index/end'
import paypal from '@/components/pay/paypal'
import malaysia from '@/components/pay/malaysia'
import little from '@/components/pay/little'
import pay from '@/components/pay/pay'
import card from '@/components/pay/card'
import cardresult from '@/components/pay/cardresult'


Vue.use(Router)

export default new Router({
//   hashbang: false, 
//   history: true,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
        redirect:'/homepage',
        children: [
            { path: "/homepage", component: homepage },
            { path: "/man", component: man },
            { path: "/woman", component: woman },
            { path: "/end", component: end },
            { path: "/rank", component: rank },
        ]
    },{ path: "/more",name:"more", component: more },
    {
          path: '/login',
          name: 'login',
          component: login
      },{
          path: '/reg',
          name: 'register',
          component: register
      },{
          path: '/personal',
          name: 'personal',
          component: personal
      },{
          path: '/mybook',
          name: 'mybook',
          component: mybook
      },{
          path: '/bookdetail',
          name: 'bookdetail',
          component: bookdetail
      },{
        path: '/cmtlist',
        name: 'cmtlist',
        component: cmtlist
    },{
          path: '/catalog',
          name: 'catalog',
          component: catalog
      },{
          path: '/read',
          name: 'read',
          component: read
      },{
        path: '/readpay',
        name: 'readpay',
        component: readpay
    },{
          path: '/loadpage',
          name: 'loadpage',
          component: loadpage
      },{
          path: '/search',
          name: 'search',
          component: search
      },{
          path: '/paypal',
          name: 'paypal',
          component: paypal
      },{
          path: '/malaysia',
          name: 'malaysia',
          component: malaysia
      },{
          path: '/little',
          name: 'little',
          component: little
      },{
        path: '/feedback',
        name: 'feedback',
        component: feedback
    },{
        path: '/changepwd',
        name: 'changepwd',
        component: changepwd
    },{
        path: '/card',
        name: 'card',
        component: card
    },{
        path: '/cardresult',
        name: 'cardresult',
        component: cardresult
    },{
        path: '/pay',
        name: 'pay',
        component: pay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js